<template>
  <svg viewBox="0 0 265 265">
    <defs>
      <radialGradient
          gradientTransform="matrix(-3.192317,0.24221405,-0.15375537,-2.0264546,574.75574,202.83459)"
          gradientUnits="userSpaceOnUse"
          r="129.64583"
          fy="68.846474"
          fx="134.57649"
          cy="68.846474"
          cx="134.57649"
          :id="radialGradientId">
        <stop offset="0"
              :stop-color="startColor"
              class="linear-gradient-start"></stop>
        <stop offset="1"
              :stop-color="stopColor"
              class="linear-gradient-stop"></stop>
      </radialGradient>
    </defs>
    <g transform="translate(0,-32.41665)">
      <path
          d="m 209.77229,252.05025 c -1.12385,0.99697 1.06855,14.11692 -0.13006,15.02264 -1.1986,0.90571 -13.22117,-4.78618 -14.48714,-3.9773 -1.26597,0.80888 -1.15298,14.11027 -2.47852,14.81733 -1.32553,0.70706 -12.30968,-6.7955 -13.6866,-6.19462 -1.37692,0.60088 -3.34612,13.75619 -4.76594,14.24718 -1.41982,0.491 -11.09507,-8.63749 -12.54904,-8.2594 -1.45397,0.37808 -5.45686,13.06337 -6.93601,13.32621 -1.47915,0.26284 -9.60728,-10.2668 -11.10249,-10.12082 -1.49521,0.14598 -7.43324,12.0489 -8.9353,12.07712 -1.50205,0.0282 -7.88291,-11.64331 -9.38255,-11.73304 -1.49964,-0.0897 -9.22659,10.73775 -10.71457,10.53064 -1.48797,-0.2071 -5.96445,-12.73312 -7.43159,-13.05633 -1.46714,-0.32321 -10.792747,9.16219 -12.230005,8.72486 -1.437257,-0.43732 -3.899117,-13.5094 -5.297631,-14.05814 -1.398515,-0.54875 -12.093157,7.36103 -13.444307,6.70425 -1.351149,-0.65678 -1.737776,-13.95303 -3.03323,-14.7138 -1.295454,-0.76076 -13.095788,5.37862 -14.32756,4.51856 -1.231772,-0.86006 0.466354,-14.0531 -0.694141,-15.00715 -1.160496,-0.95405 -13.775959,3.26376 -14.858023,2.2216 -1.082064,-1.04216 2.659001,-13.80712 1.66204,-14.93097 -0.996961,-1.12385 -14.116919,1.06855 -15.02263,-0.13006 -0.905712,-1.1986 4.786174,-13.22117 3.977296,-14.48714 -0.808878,-1.26597 -14.110274,-1.15299 -14.817332,-2.47852 -0.707058,-1.32553 6.795497,-12.30968 6.194619,-13.6866 -0.600879,-1.37692 -13.756187,-3.34612 -14.247181,-4.76594 -0.490995,-1.41982 8.637491,-11.09507 8.259408,-12.54904 C 18.91572,192.6378 6.2304261,188.6349 5.9675855,187.15576 5.7047449,185.67661 16.234388,177.54848 16.08841,176.05327 c -0.145978,-1.49521 -12.0489034,-7.43325 -12.0771183,-8.9353 -0.028215,-1.50205 11.6433103,-7.88292 11.7330323,-9.38255 0.08972,-1.49964 -10.737746,-9.2266 -10.5306404,-10.71457 0.2071055,-1.48798 12.7331214,-5.96445 13.0563334,-7.43159 0.323212,-1.46714 -9.1621891,-10.79275 -8.7248627,-12.23001 0.4373263,-1.43725 13.5094007,-3.89911 14.0581447,-5.29763 0.548744,-1.39851 -7.361029,-12.09315 -6.70425,-13.4443 0.656778,-1.35115 13.953033,-1.73778 14.713797,-3.03323 0.760764,-1.29546 -5.378616,-13.095793 -4.518557,-14.327565 0.860059,-1.231772 14.053097,0.466354 15.007148,-0.694141 0.954052,-1.160495 -3.263763,-13.775959 -2.221601,-14.858022 1.042161,-1.082064 13.807125,2.659001 14.930972,1.66204 1.123847,-0.996961 -1.068546,-14.116919 0.130057,-15.022631 1.198603,-0.905712 13.221178,4.786175 14.487148,3.977296 1.265969,-0.808878 1.152981,-14.110273 2.478512,-14.817331 1.325531,-0.707058 12.309681,6.795497 13.6866,6.194618 1.37692,-0.600878 3.34612,-13.756187 4.76594,-14.247181 1.419819,-0.490994 11.095075,8.637491 12.549045,8.259408 1.45396,-0.378082 5.45686,-13.063376 6.93601,-13.326217 1.47915,-0.262841 9.60728,10.266802 11.10249,10.120824 1.49521,-0.145977 7.43324,-12.048903 8.9353,-12.077118 1.50205,-0.02821 7.88291,11.64331 9.38255,11.733032 1.49964,0.08972 9.22659,-10.737745 10.71457,-10.53064 1.48797,0.207106 5.96445,12.733121 7.43159,13.056334 1.46713,0.323212 10.79275,-9.16219 12.23,-8.724863 1.43726,0.437326 3.89912,13.5094 5.29764,14.058144 1.39851,0.548745 12.09315,-7.361029 13.4443,-6.70425 1.35115,0.656779 1.73778,13.953034 3.03323,14.713798 1.29546,0.760764 13.09579,-5.378616 14.32756,-4.518557 1.23177,0.860059 -0.46635,14.053096 0.69414,15.007148 1.1605,0.954051 13.77596,-3.263764 14.85803,-2.221602 1.08206,1.042162 -2.659,13.807126 -1.66204,14.930973 0.99696,1.123847 14.11692,-1.068547 15.02263,0.130057 0.90571,1.198603 -4.78618,13.221176 -3.9773,14.487146 0.80888,1.26597 14.11027,1.15298 14.81733,2.47851 0.70706,1.32553 -6.79549,12.30968 -6.19462,13.6866 0.60088,1.37692 13.75619,3.34612 14.24718,4.76594 0.491,1.41982 -8.63749,11.09508 -8.2594,12.54905 0.37808,1.45396 13.06337,5.45686 13.32621,6.93601 0.26284,1.47915 -10.2668,9.60728 -10.12082,11.10249 0.14598,1.49521 12.0489,7.43324 12.07712,8.9353 0.0282,1.50205 -11.64331,7.88291 -11.73303,9.38255 -0.0897,1.49964 10.73774,9.22659 10.53064,10.71457 -0.20711,1.48797 -12.73313,5.96445 -13.05634,7.43158 -0.32321,1.46714 9.16219,10.79276 8.72487,12.23001 -0.43733,1.43726 -13.50941,3.89912 -14.05815,5.29763 -0.54874,1.39852 7.36103,12.09316 6.70425,13.44431 -0.65678,1.35115 -13.95303,1.73778 -14.7138,3.03323 -0.76076,1.29545 5.37862,13.09579 4.51856,14.32756 -0.86006,1.23177 -14.0531,-0.46635 -15.00715,0.69414 -0.95405,1.1605 3.26377,13.77596 2.2216,14.85802 -1.04216,1.08207 -13.80712,-2.659 -14.93097,-1.66204 z"
          :stroke="strokeColor"
          :style="`fill: url(#${radialGradientId});`"
          class="star"></path>
    </g>
    <g>
      <slot></slot>
    </g>
    <g>
      <text y="50%"
            x="50%"
            class="text"
            v-for="text,i in words_group"
            :dy="dY(i)"
            text-anchor="middle"
            dominant-baseline="middle"
            :fill="textFill"
            :stroke="textStroke"
            :font-size="fontSize"
            xml:space="preserve">
        {{text}}
    </text>
    </g>

  </svg>
</template>

<script>
  import uniqueId from 'lodash-es/uniqueId'

  export default {
    name: "product-badge",
    props: {
      words: {
        type: Array,
        default: () => ['', ''],
      },
      startColor: {
        type: String,
        default: "#ff7070",
      },
      stopColor: {
        type: String,
        default: "#8d0000",
      },
      strokeColor: {
        type: String,
        default: "#b91414",
      },
      textFill: {
        type: String,
        default: "#fefefe",
      },
      textStroke:{
        type: String,
        default: "#000",
      },
      fontSize: {
        type: Number,
        default: 60,
      }
    },
    data() {
      return {
        radialGradientId: uniqueId('radialGradient'),
      }
    },
    computed: {
      words_group() {
        const words = this.words,
            tspans = [],
            maxLength = this.string_length + 0
        let current = ''
        for (let i = 0, len = words.length; i < len; i++) {
          let word = words[i]
          if (current.length + word.length + 1 > maxLength) {
            tspans.push(current)
            current = ''
          }
          current += word + ' '
        }
        tspans.push(current)
        return tspans
      },
      string_length() {
        return Math.floor(250 / this.fontSize) * 2
      }
    },
    methods: {
      dY(index) {
        const num_lines = this.words_group.length
        if (num_lines % 2 === 0) {
            return (this.fontSize * (index - (num_lines/2)))+(this.fontSize/2)
        } else {
          return (this.fontSize * (index - ((num_lines-1)/2)))
        }
      }
    }

  }
</script>

<style scoped>

  .star {
    /*fill: url(#radialGradient5182);*/
    fill-opacity: 1;
    stroke-width: 4.23809585;
    stroke-linecap: round;
    stroke-miterlimit: 4;
    stroke-dasharray: none;
    stroke-opacity: 1
  }

  .linear-gradient-start {
    stop-opacity: 1;
  }

  .linear-gradient-stop {
    stop-opacity: 1;
  }

  .text {
    font-style: normal;
    font-variant: normal;
    font-weight: bold;
    font-stretch: normal;
    line-height: 1.25;
    font-family: sans-serif;
    -inkscape-font-specification: 'sans-serif, Bold';
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-variant-numeric: normal;
    font-feature-settings: normal;
    text-align: center;
    letter-spacing: 0px;
    word-spacing: 0px;
    writing-mode: lr-tb;
    text-anchor: middle;
    fill-opacity: 1;
    stroke-width: 1.32291663;
    stroke-miterlimit: 4;
    stroke-dasharray: none;
    stroke-opacity: 1;
    alignment-baseline: middle;
  }

  .tspan {
    font-style: normal;
    font-variant: normal;
    font-weight: bold;
    font-stretch: normal;
    font-size: 1em;
    font-family: sans-serif;
    -inkscape-font-specification: 'sans-serif, Bold';
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-variant-numeric: normal;
    font-feature-settings: normal;
    text-align: center;
    writing-mode: lr-tb;
    text-anchor: middle;
    fill-opacity: 1;
    stroke: #000000;
    stroke-width: 1.32291663;
    stroke-miterlimit: 4;
    stroke-dasharray: none;
    stroke-opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// ixcms/themes/heartlandtan/src/vue-src/base/heartland-product-badge.vue